// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".onboarding-wrapper{margin-top:62px}@media(max-width:960px){.onboarding-wrapper{margin-top:0}}", ""]);
// Exports
module.exports = exports;
